/**
 * Замена HashLink из react-router-hash-link
 */
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

function scrollToHash(hash, { smooth = true } = {}) {
  if (!hash) return;

  const el = document.getElementById(hash.replace("#", ""));
  if (el){
    el.scrollIntoView(true);
    //window.scrollBy(0, -56);
    return;
  }
  // поддержим #id и #some%20id
  const id = decodeURIComponent(hash.replace("#", ""));
  const el2 = document.getElementById(id);
  if (!el2) return;
  el2.scrollIntoView(true);
  //window.scrollBy(0, -56);
}

export function HashLink({ to, smooth = true, replace = false, ...rest }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Link
      {...rest}
      to={to}
      onClick={(e) => {
        // если это обычный клик по ссылке — управляем сами
        if (
          e.defaultPrevented ||
          e.button !== 0 ||
          e.metaKey ||
          e.altKey ||
          e.ctrlKey ||
          e.shiftKey
        ) {
          return;
        }

        e.preventDefault();

        const url = typeof to === "string" ? to : to.pathname + (to.search || "") + (to.hash || "");
        const [path, hash] = url.split("#");
        const targetHash = hash ? `#${hash}` : "";

        const nextPath = path || location.pathname;

        navigate(`${nextPath}${targetHash}`, { replace });

        // дождаться, пока DOM обновится
        requestAnimationFrame(() => scrollToHash(targetHash, { smooth }));
      }}
    />
  );
}